import { render } from "./IdentityScreen.vue?vue&type=template&id=22d807e4&scoped=true"
const script = {}

import "./IdentityScreen.vue?vue&type=style&index=0&id=22d807e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d807e4"]])

export default __exports__